import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Rank } from "../../models/rank.model";

@Injectable()
export class RankProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<Rank> {
    return this.http
      .get<Rank>(`${this.url}/ranks/${id}`)
      .map(response => {
        return new Rank(response);
      })
      .catch(this.handleError)
  }

  getAll(): Observable<Rank[]> {
    return this.http
      .get<Rank[]>(`${this.url}/ranks`)
      .map(response => {
        return response.map((rank) => new Rank(rank));
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/rank/rank.ts